import { createReducer } from '@reduxjs/toolkit'

import { CrawlImportActions, type CrawlImportProgress } from './actions'

export interface CrawlImportState {
  // Set while a finished crawl is being laid into a new project (OCT-5101):
  // how many of its blocks are already parsed. Null outside that step.
  preparing: CrawlImportProgress | null
}

const initialState: CrawlImportState = { preparing: null }

export const crawlImportReducer = createReducer(initialState, (builder) => {
  builder.addCase(CrawlImportActions.progress, (state, { payload }) => {
    state.preparing = payload
  })
})
